"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenteredContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CenteredContainer = exports.CenteredContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__CenteredContainer",
  componentId: "sc-cpzvcb-0"
})(["height:100%;padding:30px 50px 0 ", ";display:flex;flex-direction:column;max-width:1020px;width:100%;margin:0 auto;position:relative;"], function (_ref) {
  var noPaddingLeft = _ref.noPaddingLeft;
  return noPaddingLeft ? '0' : '';
});
//# sourceMappingURL=styles.js.map